'use client';

import { c as _c } from "react/compiler-runtime";
import type { ProjectProduct } from '@/api/generated/model/projectProduct';
import { Badge } from '@/comps/primitives/badge';
import { getProjectProductConfig } from '@/domains/dashboard/components/project-product.config';
import { cn } from '@/utils/shad';
type ProjectProductBadgeProps = {
  product: ProjectProduct | undefined;
  className?: string;
  showIcon?: boolean;
};
export function ProjectProductBadge(t0) {
  const $ = _c(13);
  const {
    product,
    className,
    showIcon: t1
  } = t0;
  const showIcon = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== product) {
    t2 = getProjectProductConfig(product);
    $[0] = product;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const config = t2;
  const Icon = config.icon;
  let t3;
  if ($[2] !== className) {
    t3 = cn("max-w-full gap-1.5 font-normal", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== Icon || $[5] !== showIcon) {
    t4 = showIcon ? <Icon className="size-3 shrink-0 text-muted-foreground" strokeWidth={1.8} aria-hidden={true} /> : null;
    $[4] = Icon;
    $[5] = showIcon;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== config.title) {
    t5 = <span className="truncate">{config.title}</span>;
    $[7] = config.title;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <Badge variant="outline" pill={true} className={t3}>{t4}{t5}</Badge>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}